import { defineMessages } from 'react-intl';

export const estimationItemDetailEditationMessageDefinitions = defineMessages({
  phaseName: {
    id: 'estimationDetail.estimationItemEditation.phaseName',
    defaultMessage: 'Phase Name',
  },
  phaseLead: {
    id: 'estimationDetail.estimationItemEditation.phaseLead',
    defaultMessage: 'Phase Lead',
  },
  description: {
    id: 'estimationDetail.estimationItemEditation.description',
    defaultMessage: 'Description',
  },
  descriptionPlaceholder: {
    id: 'estimationDetail.estimationItemEditation.descriptionPlaceholder',
    defaultMessage: 'Meaningful short description for management (max 210 characters)',
  },
  methodology: {
    id: 'estimationDetail.estimationItemEditation.methodology',
    defaultMessage: 'Methodology',
  },
  estimate: {
    id: 'estimationDetail.estimationItemEditation.estimate',
    defaultMessage: 'Estimate',
  },
});
